// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectedModeReport {
  background-color: #a25035;
  color: #fff;
  border: none;
  align-items: center;
  justify-content: center;
  margin: 5%;
  height: 30%;
  transform: scale(1.02);
  font-weight: 500;
  font-family: "Merriweather Sans";
  cursor: pointer;
}

.input-fields {
  display: flex;
  align-items: row;
  margin: 0%;
}

.selectedReport {
  color: black;
  transform: scale(1.05);
  margin: 3%;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.notSelectedReport {
  margin: 3%;
  color: grey;
  cursor: pointer;
  font-size: 14px;
}

.reports-div {
  display: flex;
  flex-direction: column;
}

.label-style1 {
  margin: 2%;
  width: 15%;
  margin-top: 2%;
  font-weight: 500;
  margin-left: 12%;
}

.notSelectedModeReport {
  border: none;
  align-items: center;
  justify-content: center;
  margin: 5% 8%;
  height: 30%;
  background-color: #f8ecd1;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  font-weight: 500;
  font-family: Merriweather Sans;
  cursor: pointer;
}

.report-user {
  display: inline-block;

  background: none;
  border: none;

  color: black;

  display: inline-block;
}

.report-user:hover {
  display: inline-block;

  background-color: grey;
}
.reportNav-outerdiv {
  height: 70vh;
}
.reportNav-innerdiv {
  display: block;
  text-align: center;
  margin-top: 5px;
}
.reportNav-search {
  width: 50%;
  margin: 2%;
  margin-top: 0%;
  margin-left: 8%;
}
.reportNav-innerdiv1 {
  display: inline-block;
}
.reportNav-icon {
  font-size: 25px;
  margin-bottom: 1px;
}
.reportNav-cardDiv {
  display: flex;
  flex-direction: row;
  height: 10%;
  margin-top: 10%;
}
.reportNav-cardDiv1 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.report-downloadDiv {
  width: 100%;
  height: 30px;
  margin-top: 6%;
}
.report-downloadIcon {
  font-size: 20px;
  margin-bottom: 1px;
}
.report-TbChevronsLeft {
  font-size: 30px;
  position: relative;
  top: 15%;
}

.selectedMode1 {
  width: 25%;
  display: inline-block;
  margin: 2%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #a25035;
  color: #fff;
  font-weight: 500;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  transform: scale(1.1);
}

.notSelectedMode1 {
  width: 25%;
  display: inline-block;
  margin: 2%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8ecd1;
  font-weight: 500;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
`, "",{"version":3,"sources":["webpack://./src/components/modules/userManagement/userReport/UserReportNav.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,4EAA4E;EAC5E,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,qBAAqB;;EAErB,gBAAgB;EAChB,YAAY;;EAEZ,YAAY;;EAEZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;;EAErB,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,UAAU;EACV,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,4EAA4E;EAC5E,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,4EAA4E;AAC9E","sourcesContent":[".selectedModeReport {\n  background-color: #a25035;\n  color: #fff;\n  border: none;\n  align-items: center;\n  justify-content: center;\n  margin: 5%;\n  height: 30%;\n  transform: scale(1.02);\n  font-weight: 500;\n  font-family: \"Merriweather Sans\";\n  cursor: pointer;\n}\n\n.input-fields {\n  display: flex;\n  align-items: row;\n  margin: 0%;\n}\n\n.selectedReport {\n  color: black;\n  transform: scale(1.05);\n  margin: 3%;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.notSelectedReport {\n  margin: 3%;\n  color: grey;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.reports-div {\n  display: flex;\n  flex-direction: column;\n}\n\n.label-style1 {\n  margin: 2%;\n  width: 15%;\n  margin-top: 2%;\n  font-weight: 500;\n  margin-left: 12%;\n}\n\n.notSelectedModeReport {\n  border: none;\n  align-items: center;\n  justify-content: center;\n  margin: 5% 8%;\n  height: 30%;\n  background-color: #f8ecd1;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  font-weight: 500;\n  font-family: Merriweather Sans;\n  cursor: pointer;\n}\n\n.report-user {\n  display: inline-block;\n\n  background: none;\n  border: none;\n\n  color: black;\n\n  display: inline-block;\n}\n\n.report-user:hover {\n  display: inline-block;\n\n  background-color: grey;\n}\n.reportNav-outerdiv {\n  height: 70vh;\n}\n.reportNav-innerdiv {\n  display: block;\n  text-align: center;\n  margin-top: 5px;\n}\n.reportNav-search {\n  width: 50%;\n  margin: 2%;\n  margin-top: 0%;\n  margin-left: 8%;\n}\n.reportNav-innerdiv1 {\n  display: inline-block;\n}\n.reportNav-icon {\n  font-size: 25px;\n  margin-bottom: 1px;\n}\n.reportNav-cardDiv {\n  display: flex;\n  flex-direction: row;\n  height: 10%;\n  margin-top: 10%;\n}\n.reportNav-cardDiv1 {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n.report-downloadDiv {\n  width: 100%;\n  height: 30px;\n  margin-top: 6%;\n}\n.report-downloadIcon {\n  font-size: 20px;\n  margin-bottom: 1px;\n}\n.report-TbChevronsLeft {\n  font-size: 30px;\n  position: relative;\n  top: 15%;\n}\n\n.selectedMode1 {\n  width: 25%;\n  display: inline-block;\n  margin: 2%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #a25035;\n  color: #fff;\n  font-weight: 500;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  transform: scale(1.1);\n}\n\n.notSelectedMode1 {\n  width: 25%;\n  display: inline-block;\n  margin: 2%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8ecd1;\n  font-weight: 500;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
